import { Audited } from '@ianesthesie-kit/services';

export enum PremedicationType {
  TREATMENT = 'TREATMENT',
  CARE = 'CARE'
}

export enum PremedicationRoute {
  ORAL = 'ORAL',
  IV = 'IV',
  SC = 'SC',
  IM = 'IM',
  CUTANEOUS = 'CUTANEOUS',
  INHALED = 'INHALED',
  RECTAL = 'RECTAL'
}

export enum PremedicationTiming {
  VEILLE = 'VEILLE',
  MORNING = 'MORNING',
  H2 = 'H2',
  H1 = 'H1',
  BLOCK = 'BLOCK',
  RECOVERY = 'RECOVERY',
  POSTOP = 'POSTOP'
}

export interface PremedicationOrder extends Audited {
  type: PremedicationType;
  /**
   * Either free text or — for a built-in care act — a `doctor-dashboard.*`
   * translation key. When {@link nameTranslatable} is true the key is localized
   * for display; see PREMED_CARE_OPTIONS / premedDisplayName.
   */
  name: string;
  /** True when {@link name} is a care-option translation key (mirrors meds). */
  nameTranslatable?: boolean;
  dosage?: string;
  route?: PremedicationRoute;
  timings: PremedicationTiming[];
  ifNeeded?: boolean;
  condition?: string;
  comment?: string;
  orderIndex?: number;
}
